// import RequestManager from 'api/RequestManager'
import { useNavigate } from 'react-router-dom'
// import * as nativeApp from 'utils/nativeApp'

type ProductKey = 'qr_board' | 'obituary' | 'additional_profile'

interface Options {
  related?: board.BoardToOrderRelated
  profileName?: string
  modal?: string
}

const useStore = () => {
  const navigate = useNavigate()
  const startTransaction = (productKey?: ProductKey, options?: Options) => {
    const params = new URLSearchParams()
    if (productKey) params.set('productKey', productKey)
    if (options?.profileName) params.set('profileName', options.profileName)
    if (options?.modal) params.set('modal', options.modal)
    if (options?.related) {
      params.set('relatedObject', options.related.object)
      params.set('relatedId', options.related.id)
    }

    // if (nativeApp.isNativeApp()) {
    //   const token = RequestManager.jwt.get()
    //   if (token) params.set('token', token)
    //   const search = params.toString()
    //   const link = `${window.location.origin}/order${search ? `?${search}` : ''}`
    //   nativeApp.openStore(link)

    // } else {
      const search = params.toString()
      const path = `/order${search ? `?${search}` : ''}`
      navigate(path)
    // }
  }

  return startTransaction
}

export default useStore